// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const SquareArrowTopRight_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 9.75a.75.75 0 0 1-1.5 0V5.561l-6.218 6.22a.75.75 0 0 1-1.062-1.062L18.44 4.5h-4.19a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75ZM17.25 12a.75.75 0 0 0-.75.75v6.75h-12v-12h6.75a.75.75 0 0 0 0-1.5H4.5A1.5 1.5 0 0 0 3 7.5v12A1.5 1.5 0 0 0 4.5 21h12a1.5 1.5 0 0 0 1.5-1.5v-6.75a.75.75 0 0 0-.75-.75Z',
  viewBox: '0 0 24 24',
  glyph: 'SquareArrowTopRight_Stroke2_Corner0_Rounded',
})

export const SquareBehindSquare_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.648 16.125a.75.75 0 0 1-.273 1.023l-9 5.25a.75.75 0 0 1-.756 0l-9-5.25a.75.75 0 0 1 .756-1.296L12 20.882l8.625-5.03a.75.75 0 0 1 1.023.273Zm-1.023-4.773L12 16.382l-8.625-5.03a.75.75 0 0 0-.75 1.296l9 5.25a.75.75 0 0 0 .756 0l9-5.25a.75.75 0 1 0-.756-1.296ZM2.25 7.5a.75.75 0 0 1 .375-.648l9-5.25a.75.75 0 0 1 .756 0l9 5.25a.75.75 0 0 1 0 1.296l-9 5.25a.75.75 0 0 1-.756 0l-9-5.25A.75.75 0 0 1 2.25 7.5Zm2.239 0L12 11.882 19.511 7.5 12 3.118Z',
  viewBox: '0 0 24 24',
  glyph: 'SquareBehindSquare_Stroke2_Corner2_Rounded',
})

export const SquareBehindSquare4_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M20.25 3h-12a.75.75 0 0 0-.75.75V7.5H3.75a.75.75 0 0 0-.75.75v12a.75.75 0 0 0 .75.75h12a.75.75 0 0 0 .75-.75V16.5h3.75a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75ZM15 19.5H4.5V9H15Zm4.5-4.5h-3V8.25a.75.75 0 0 0-.75-.75H9v-3h10.5Z',
  viewBox: '0 0 24 24',
  glyph: 'SquareBehindSquare4_Stroke2_Corner0_Rounded',
})
